import store from '../redux/store/store.js'
import { storeTokens } from '../redux/actions/authActions';
import { jwtDecode } from "jwt-decode";
const BASE_URL = process.env.REACT_APP_API_URL + "/api"

export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; // current time in seconds
    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Invalid token:', error);
    return false;
  }
  // const payload = JSON.parse(atob(token.split('.')[1]));
  // return payload.exp * 1000 > Date.now();
};

const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  // console.log('####### refreshAccessToken  ', refreshToken)
  if (!refreshToken) return null;

  const response = await fetch(`${BASE_URL}/token/refresh/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh: refreshToken }),
  });

  if (response.ok) {
    const data = await response.json();

    localStorage.setItem('accessToken', data.access);
    localStorage.setItem('refreshToken', data.refresh);
    store.dispatch(storeTokens(data.access, data.refresh));
    return data.access;
  }

  return null;
};

// export const fetchApi = async (endpoint, { method, headers = {}, body, requiresAuth = false } = {}) => {
//   console.log('fetchApi -- endpoint ',endpoint);
//   console.log(' headers ' , headers);
//   console.log(' method ' , method);
//   // try {
//     let accessToken = localStorage.getItem('accessToken');
//     if (requiresAuth && !isTokenValid(accessToken)) {
//       accessToken = await refreshAccessToken();
//       if (!accessToken) {
//         window.alert('Session expired. Please log in again.');
//         localStorage.removeItem('accessToken');
//         localStorage.removeItem('refreshToken');
//         window.location.href = '/login';
//         return; // Stop further execution
//       }
//       store.dispatch(storeTokens({accessToken}));
//       // store.dispatch(setAccessToken(accessToken, refreshToken));
//       // store.dispatch(storeTokens({ accessToken }));
//     }
//     console.log('requiresAuth  ',requiresAuth)
//     const authHeaders = requiresAuth
//       ? { Authorization: `Bearer ${accessToken}` }
//       : {};
//     const combinedHeaders = {
//       'Content-Type': 'application/json',
//       ...headers,
//       ...authHeaders,
//     };
//     console.log('method ',method)
//     console.log('combinedHeaders ',combinedHeaders)
//     console.log(' BASE_URL ' , BASE_URL , '--  endpoint ', endpoint  ,' method :',method ,' accessToken : ',accessToken, ' # body ',body);
//     const response = await fetch(`${BASE_URL}/${endpoint}`, {
//       method,
//       headers: combinedHeaders,
//       body: body ? JSON.stringify(body) : undefined,
//     });
//     console.log('~~~ response ... ',response)
//     const contentType = response.headers.get('Content-Type');

//     console.log('response  ----------- ',response)
//     if (!response.ok) {
//       if(endpoint=='logout/'){
//         localStorage.clear()
//         window.location.href='/login'
//       }
//       return await response.json();
//     }
//     if(endpoint=='logout/'){
//       localStorage.clear()
//       window.location.href='/login'
//     }
//     return await response.json() ;
//     // const text = await response.text();
//     // return text ? JSON.parse(text) : {};
//   // } catch (error) {
//   //   console.error(`Error in fetchApi: ${error.message}`);
//   //   throw error;
//   // }
// };

let refreshInProgress = false;
let refreshPromise = null;
export const fetchApi = async (endpoint, { method, headers = {}, body, requiresAuth = false } = {}) => {
  const state = store.getState();
  const viewMode = state.partner.viewMode
  const customer = state.partner.partnerCustomer.customerId
  const userType = state.auth.userDetails.user_type
  // Add this array somewhere accessible or pass it as an argument
  const requiredEndpoints = [
    'list-schedule/',
    'create-schedule/',
    'update-schedule/',
    'delete-schedule/',
    'create-calender/',
    'list-calender/',
    'update-calender/',
    'delete-calendar/',
    'customer-workflow-list/',
    'workflows_filter/',
    'workflow-audit-log/list/',
    'auditlog/list/',
    'client-settings-detail/',
    'client-settings-update/',
    'client-settings-create/',
    'partner-customer-user/list/',
    'dashboard-partner-count/',
    'user/create/',
    '/user/update/',
    'team/team-list/',
    'team/team-create/',
    'team-user-create-update/',
    'team/team-update/',
    'team/team-workflow-assign/',
    'tag/tag-workflow-assign/',
    'tag/custom-tag-list/',
    'create-customer-workflow/',
    'config-file-upload/',
    'edit-customer-workflow/',
    'workflow_activate/',
    'schedule-workflow-create/',
    'schedule-workflow-date-update/',
    'schedule-workflow-activate/',
    'user_workflow-mapping-list/',
    'user_workflow-mapping-create/',
    'user_workflow-mapping-update/',
    'interaction-data/',
    'connectionlist/',
    'oauth2/get-authorization-url/',
    'connectiondropdown/',
    'connectioncreate/',
    'connectiondelete/',
    'run_history_log_search/',
    'retry-workflow/',
    'interaction-schema/',
    'workflow-audit-trail-list/',
    'cancel-workflow-run/',
    'report-templates/',
    'customer-report-templates/',
    'generate-report/',
    'customer-report-history/',
    'customer-report-template-create/',
    'report-insight/',
    'task-list/',
    'workflow-library/',
    'integration-list/',
    'task-schema'
  ];
  const shouldIncludeCustomer = requiredEndpoints.some(required =>
    endpoint.includes(required)
  );


  try {
    let accessToken = localStorage.getItem('accessToken');
    if (requiresAuth && !isTokenValid(accessToken)) {

      if (refreshInProgress) {
        // Wait for the ongoing refresh to complete
        accessToken = await refreshPromise;
      } else {
        refreshInProgress = true;
        refreshPromise = refreshAccessToken().finally(() => {
          refreshInProgress = false;
          refreshPromise = null;
        });

        accessToken = await refreshPromise;
      }
      if (!accessToken) {
        //for unified screen
        const isWorkflowList = window.location.pathname.includes('/workflow-list');

        if (isWorkflowList) {
          const params = new URLSearchParams(window.location.search);
          const hasToken = params.get('session_id');

          if (!hasToken) {
            const parts = window.location.pathname.split('/').filter(Boolean);
            const baseIndex = parts.indexOf('workflow-list');
            const [system, slug] = parts.slice(baseIndex + 1);
            const slugPath = slug ? `/${slug}` : '';
            const systemPath = system ? `/${system}` : '';
            window.location.href = `${BASE_URL}/unified/auth-redirect${systemPath}${slugPath}`;
          }
          return;
        }
        // window.alert('Session expired. Please log in again.');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userId');
        localStorage.clear();
        // store.dispatch(logoutSuccess())
        // sessionStorage.clear();
        window.location.href = '/login';
        return;
      }

    }

    const timezone = {
      "Accept-Language": localStorage.getItem("preferred_language"),
      "timezone": localStorage.getItem("timeZone")
    }
    const authHeaders = requiresAuth
      ? { Authorization: `Bearer ${accessToken}` }
      : {};
    let isFormData = body instanceof FormData;
    const combinedHeaders = {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }), ...headers,
      ...authHeaders,
      ...(endpoint === 'login/' || endpoint === 'logout/' ? {} : timezone),
    };

    if (
      method === 'POST' &&
      (userType === 2 || userType === 3) &&
      viewMode === 'customer-view' &&
      shouldIncludeCustomer
    ) {
      if (body instanceof FormData) {
        body.append(
          'customer',
          typeof customer === 'object' ? JSON.stringify(customer) : String(customer)
        );
      } else {
        body.customer = customer;
      }
    }


    const finalBody = isFormData ? body : JSON.stringify(body);
    // console.log('method ', method)
    // console.log(' BASE_URL ', BASE_URL, '--  endpoint ', endpoint, ' method :', method, ' accessToken : ', accessToken, ' # body ', body);
    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method,
      headers: combinedHeaders,
      body: finalBody
    });

    // const contentType = response.headers.get('Content-Type');


    if (!response.ok) {
      if (endpoint === 'logout/' || response.status === 401) {
        const isWorkflowList = window.location.pathname.includes('/workflow-list');

        if (isWorkflowList) {
          const params = new URLSearchParams(window.location.search);
          const hasToken = params.get('session_id');

          if (!hasToken) {
            // Extract slug and system from path only when needed
            const parts = window.location.pathname.split('/').filter(Boolean);
            const baseIndex = parts.indexOf('workflow-list');
            const [system, slug] = parts.slice(baseIndex + 1);

            const slugPath = slug ? `/${slug}` : '';
            const systemPath = system ? `/${system}` : '';
            window.location.href = `${BASE_URL}/unified/auth-redirect${systemPath}${slugPath}`;
          }
        } else {
          localStorage.clear();
        }
      }
      let errorData;
      try {
        errorData = await response.json();
      } catch (parseErr) {
        errorData = {
          errors: [{
            detail: 'Bad response',
            code: 'invalid_response'
          }]
        };
      }
      throw errorData;

    }
    if (endpoint === 'logout/') {
      localStorage.clear()
      localStorage.setItem('currentPage', "/login");
      window.location.href = '/login'
    }
    const contentType = response.headers.get("content-type") || "";

    // Only treat specific file types as blob
    if (
      contentType.includes("text/csv") ||
      contentType.includes("application/vnd.ms-excel") ||
      contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
      contentType.includes("application/pdf") ||
      contentType.includes("application/octet-stream")
    ) {
      return await response.blob();
    }
    try {
      return await response.json();
    } catch (parseErr) {
      throw {
        errors: [{
          detail: 'Bad response',
          code: 'invalid_response'
        }]
      };
    }
  } catch (error) {
    console.error(`Error in fetchApi:`, error);
    if (error.errors?.[0]?.code === "permission_denied") {
      const isWorkflowList = window.location.pathname.includes('/workflow-list');
      window.location.replace(isWorkflowList ? '/access-denied' : '/403');
      return;
    }

    if (error instanceof TypeError) {
      throw {
        errors: [{
          detail: 'Bad response',
          code: 'invalid_response'
        }]
      };
    }

    throw error;
  }
};